import { httpClient } from '@bcba/client-auth';
import { baseCropPledgePath } from '.';

export const createCropPledge = async (): Promise<string> => {
  const { data } = await httpClient.post(`${baseCropPledgePath}`);

  return data;
};

export default createCropPledge;
